/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class AuthenticationModelKey {
  static readonly CREDENTIALS = 'kit-authentication/model/credentials';
  static readonly USER = 'kit-authentication/model/user';
}
